import { render, staticRenderFns } from "./Caixas.vue?vue&type=template&id=237360f6&"
import script from "./Caixas.vue?vue&type=script&lang=js&"
export * from "./Caixas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports